import { render, staticRenderFns } from "./EstatisticasAcesso.html?vue&type=template&id=6091732d&"
import script from "./EstatisticasAcesso.vue?vue&type=script&lang=js&"
export * from "./EstatisticasAcesso.vue?vue&type=script&lang=js&"
import style0 from "./EstatisticasAcesso.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports